var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticStyle:{"color":"red"},attrs:{"id":_vm.elementId}},[_vm._v("Not found "+_vm._s(_vm.type)+" Component")])}
var staticRenderFns = []

export { render, staticRenderFns }